import React from "react";

const HeroSection = () => {
  return (
    <section id="home" class="section-hero">
      <div class="hero-description container">
        <h1 class="heading-hero">
          Let's build something that suits your bussiness
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
